<template>
  <div class="add-product" style="background-color: white; padding: 15px">
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
      height="80vh"
    >
      <el-table-column :label="$t('system.txyw') + ':'" align="center">
        <template #default="scope">
          {{ scope.row.noticeName || $t("system." + scope.row.wname) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('system.txdx')" align="center">
        <template #default="scope">
          <el-checkbox v-model="scope.row.self" true-label="1" false-label="0">{{ $t("system.acUser") }}</el-checkbox>
          <el-checkbox v-model="scope.row.repair" true-label="1" false-label="0">{{ $t("system.yyUser") }}</el-checkbox>
        </template>
      </el-table-column>
      <el-table-column :label="$t('system.txLock')" align="center" width="150px">
        <template #default="scope">
          <el-switch v-model="scope.row.enabled" active-value="1" inactive-value="0"> </el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="$t('system.sendType')" align="center">
        <template #default="scope">
          <el-checkbox v-model="scope.row.phone" true-label="1" false-label="0">{{ $t("system.sms") }}</el-checkbox>
          <el-checkbox
            v-model="scope.row.email"
            true-label="1"
            false-label="0"
            @change="emailChangeHandler($event, scope.$index, scope.row)"
          >
            {{ $t("system.email") }}
          </el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="name" :label="$t('system.txnrck')" align="center">
        <template #default="scope">
          <el-button type="text" @click="handlerLookTips(1, scope.row.phoneText)">{{ $t("system.sms") }}</el-button>
          <el-button type="text" @click="handlerLookTips(2, scope.row.emailText)">{{ $t("system.email") }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="name" :label="$t('system.cz')" fixed="right" align="center" min-width="220">
        <template #default="scope">
          <el-button type="text" icon="el-icon-edit-outline" @click="handlerExitOne(scope.row)">{{
            $t("system.bjyjtx")
          }}</el-button>
          <el-button type="text" icon="el-icon-message" @click="handlerEditSms(scope.row)">{{
            $t("system.bjdxtx")
          }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-row :gutter="20" style="margin: 10px 0px">
      <el-col style="line-height: 2; color: #666">{{ $t("system.xxtxTip") }}</el-col>
      <el-col style="line-height: 2; color: #666">
        {{ $t("system.dxsf") }}<span style="color: #ff2a6c">${{ smsprice }}</span
        >{{ $t("system.yt") }}</el-col
      >
      <el-col style="line-height: 2; color: #666">
        {{ $t("system.yjsf") }}<span style="color: #ff2a6c">$0.01</span>{{ $t("system.yt") }}</el-col
      >
    </el-row> -->
    <el-row :gutter="20" style="margin: 10px 0px">
      <el-button :disabled="loading" @click="reset"> {{ $t("system.reset") }}</el-button>
      <el-button :loading="loading" :disabled="!configLoaded" type="primary" @click="handlerSave">{{ $t("system.save") }}</el-button>
    </el-row>
    <!-- 查看提醒内容 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="lookTips.title"
      :visible.sync="lookTips.dialogVisible"
      width="30%"
    >
      <span style="white-space: pre-wrap;">{{ lookTips.content }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lookTips.dialogVisible = false">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="lookTips.dialogVisible = false">{{ $t("common.definite") }}</el-button>
      </span>
    </el-dialog>
    <!-- 邮件编辑 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('system.yjbj')"
      :visible.sync="exitDialogVisible"
      width="60%"
    >
      <el-form ref="form" :disabled="loading" :model="nowRow" label-width="110px">
        <el-form-item :label="$t('system.txyw')">{{ nowRow.noticeName || $t("system." + nowRow.wname) }}</el-form-item>

        <el-form-item :label="$t('system.yjbt')" required>
          <el-input style="max-width: 240px" :maxlength="isHardwareNotice(nowRow) ? 255 : undefined" v-model="nowRow.emailTitle" :placeholder="$t('system.pyjbt')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('system.yjnr')" required>
          <el-row style="margin-top: 20px;">
            <el-col :span="16">
              <el-input 
                type="textarea" 
                :rows="8" 
                v-model="nowRow.emailText" 
                :placeholder="$t('system.pyjnr')"
                :maxlength="isHardwareNotice(nowRow) ? 4000 : 500"
                show-word-limit
              />
            </el-col>
            <el-col :span="8">
              <div style="background-color: #f2f2f2; margin-left: 4%; padding: 4%">
                <div style="color: #aaa">{{ $t("system.djTip") }}</div>
                <ul>
                  <template v-if="nowRow.type == 1">
                    <li v-for="(item, index) in ddkeywords" :key="index" style="line-height: 2">
                      <el-button style="padding: 0" type="text" @click="handlerAddToEmailPoint(item.look)">
                        {{ item.look }}</el-button
                      >
                    </li>
                  </template>
                  <template v-if="nowRow.type == 2">
                    <li v-for="(item, index) in jqkeywords" :key="index" style="line-height: 2">
                      <el-button style="padding: 0" type="text" @click="handlerAddToEmailPoint(item.look)">
                        {{ item.look }}</el-button
                      >
                    </li>
                  </template>
                  <template v-if="isHardwareNotice(nowRow)">
                    <li v-for="item in hardwareKeywords" :key="item.send" style="line-height: 2">
                      <el-button style="padding: 0" type="text" @click="handlerAddToEmailPoint(item.look)">{{ item.look }}</el-button>
                    </li>
                  </template>
                  <template v-if="nowRow.type == 3">
                    <li v-for="(item, index) in zhkeywords" :key="index" style="line-height: 2">
                      <el-button style="padding: 0" type="text" @click="handlerAddToEmailPoint(item.look)">
                        {{ item.look }}</el-button
                      >
                    </li>
                  </template>
                </ul>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="loading" @click="exitDialogVisible = false">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" :loading="loading" @click="saveEmailContent">{{ $t("common.definite") }}</el-button>
      </span>
    </el-dialog>
    <!-- 短信编辑 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('system.dxbj')"
      :visible.sync="smsDialogVisible"
      width="60%"
    >
      <el-form ref="smsForm" :disabled="loading" :model="nowRow" label-width="110px">
        <el-form-item :label="$t('system.txyw')">{{ nowRow.noticeName || $t("system." + nowRow.wname) }}</el-form-item>

        <el-form-item :label="$t('system.dxbt')" required>
          <el-input style="max-width: 240px" :maxlength="isHardwareNotice(nowRow) ? 255 : undefined" v-model="nowRow.phoneTitle" :placeholder="$t('system.pdxbt')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('system.dxnr')" required>
          <el-row style="margin-top: 20px;">
            <el-col :span="16">
              <el-input 
                type="textarea" 
                :rows="8" 
                v-model="nowRow.phoneText" 
                :placeholder="$t('system.pdxnr')"
                :maxlength="isHardwareNotice(nowRow) ? 4000 : 160"
                show-word-limit
              />
            </el-col>
            <el-col :span="8">
              <div style="background-color: #f2f2f2; margin-left: 4%; padding: 4%">
                <div style="color: #aaa">{{ $t("system.djTip") }}</div>
                <ul>
                  <template v-if="nowRow.type == 1">
                    <li v-for="(item, index) in ddkeywords" :key="index" style="line-height: 2">
                      <el-button style="padding: 0" type="text" @click="handlerAddToSmsPoint(item.look)">
                        {{ item.look }}</el-button
                      >
                    </li>
                  </template>
                  <template v-if="nowRow.type == 2">
                    <li v-for="(item, index) in jqkeywords" :key="index" style="line-height: 2">
                      <el-button style="padding: 0" type="text" @click="handlerAddToSmsPoint(item.look)">
                        {{ item.look }}</el-button
                      >
                    </li>
                  </template>
                  <template v-if="isHardwareNotice(nowRow)">
                    <li v-for="item in hardwareKeywords" :key="item.send" style="line-height: 2">
                      <el-button style="padding: 0" type="text" @click="handlerAddToSmsPoint(item.look)">{{ item.look }}</el-button>
                    </li>
                  </template>
                  <template v-if="nowRow.type == 3">
                    <li v-for="(item, index) in zhkeywords" :key="index" style="line-height: 2">
                      <el-button style="padding: 0" type="text" @click="handlerAddToSmsPoint(item.look)">
                        {{ item.look }}</el-button
                      >
                    </li>
                  </template>
                </ul>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="loading" @click="smsDialogVisible = false">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" :loading="loading" @click="saveSmsContent">{{ $t("common.definite") }}</el-button>
      </span>
    </el-dialog>
    <!-- 跳转钱包提示 -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('common.tip')"
      :visible.sync="dialogToWallet"
      width="400px"
      :close-on-click-modal="false"
      @close="handlerCloseWallet">
      <span class="el-icon-info" style="color: #eaa74d; font-size: 20px; margin-right: 4px"></span>
      <span>{{ $t("system.yebz") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handlerCloseWallet">{{ $t("common.cancel") }}</el-button>
        <el-button size="small" type="primary" @click="handlerChangeToWallet"
          >{{ $t("common.definite") }}<span v-if="walletTime > 0">({{ walletTime }})</span></el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    // 需要的 extensions
    Doc,
    Text,
    Paragraph,
    Heading,
    Bold,
    Underline,
    Italic,
    Strike,
    ListItem,
    BulletList,
    OrderedList,
    Link,
    Image,
    CodeBlock,
    Blockquote,
    TodoItem,
    TodoList,
    TextAlign,
    FontSize,
    FontType,
    Fullscreen,
    TextHighlight,
    TextColor,
    FormatClear,
    Table,
    TableHeader,
    TableCell,
    TableRow,
    History,
    TrailingNode,
    HardBreak,
    HorizontalRule,
    LineHeight,
    Indent
  } from "element-tiptap";
  export default {
    name: "SystemConfig",
    beforeRouteLeave(to, from, next) {
      if (JSON.stringify(this.copyData) === JSON.stringify(this.tableData)) {
        next();
        return;
      }
      // 这里需要elementui的支持，如果使用其他界面组件自行替换即可
      this.$confirm(this.$t("system.leaveTip"), this.$t("system.warn"), {
        confirmButtonText: this.$t("helpcenter.confirm"),
        cancelButtonText: this.$t("temperature.exportqx"),
        type: "warning"
      })
        .then(() => {
          // 正常跳转
          next();
        })
        .catch(() => {
          // 如果取消跳转地址栏会变化，这时保持地址栏不变
          window.history.go(1);
        });
    },
    data() {
      return {
        dialogToWallet: false,
        walletTime: 3,
        loading: false,
        setting: {},
        configLoaded: false,
        tableData: [],
        copyData: [],
        smsprice: "", //短信费用
        lookTips: {
          title: "",
          dialogVisible: false,
          content: ""
        },
        exitDialogVisible: false,
        smsDialogVisible: false,
        nowRow: {},
        // 全字典
        keywords: [
          ...['faultType', 'faultReason', 'faultDetail', 'cameraNo', 'occurredAt'].map(key => ({
            send: '{' + key + '}', look: '【' + this.$t('system.' + key) + '】'
          })),
          {
            send: "{nickName}",
            look: "【" + this.$t("system.nickName") + "】"
          },
          {
            send: "{userName}",
            look: "【" + this.$t("system.userName") + "】"
          },
          {
            send: "{orderNo}",
            look: "【" + this.$t("system.orderNumber") + "】"
          },
          {
            send: "{orderPrice}",
            look: "【" + this.$t("system.orderPrice") + "】"
          },
          {
            send: "{productName}",
            look: "【" + this.$t("system.goodsName") + "】"
          },
          {
            send: "{machineName}",
            look: "【" + this.$t("system.equipmentName") + "】"
          },
          {
            send: "{lineNo}",
            look: "【" + this.$t("system.lineNo") + "】"
          },
          {
            send: "{machineNo}",
            look: "【" + this.$t("system.equipmentNo") + "】"
          },
          {
            send: "{machineAddress}",
            look: "【" + this.$t("system.machineAddress") + "】"
          },
          {
            send: "{walletBalance}",
            look: "【" + this.$t("system.walletBalance") + "】"
          },
          {
            send: "{walletEntry}",
            look: "【" + this.$t("system.walletEntry") + "】"
          }
        ],
        // 订单模块
        ddkeywords: [
          {
            send: "{nickName}",
            look: "【" + this.$t("system.nickName") + "】"
          },
          {
            send: "{userName}",
            look: "【" + this.$t("system.userName") + "】"
          },
          {
            send: "{orderNo}",
            look: "【" + this.$t("system.orderNumber") + "】"
          },
          {
            send: "{orderPrice}",
            look: "【" + this.$t("system.orderPrice") + "】"
          },
          {
            send: "{productName}",
            look: "【" + this.$t("system.goodsName") + "】"
          },
          {
            send: "{machineName}",
            look: "【" + this.$t("system.equipmentName") + "】"
          },
          {
            send: "{lineNo}",
            look: "【" + this.$t("system.lineNo") + "】"
          },
          {
            send: "{machineNo}",
            look: "【" + this.$t("system.equipmentNo") + "】"
          },
          {
            send: "{machineAddress}",
            look: "【" + this.$t("system.machineAddress") + "】"
          }
        ],
        // 订单模块
        jqkeywords: [
          {
            send: "{nickName}",
            look: "【" + this.$t("system.nickName") + "】"
          },
          {
            send: "{userName}",
            look: "【" + this.$t("system.userName") + "】"
          },
          {
            send: "{machineName}",
            look: "【" + this.$t("system.equipmentName") + "】"
          },
          {
            send: "{machineNo}",
            look: "【" + this.$t("system.equipmentNo") + "】"
          },
          {
            send: "{machineAddress}",
            look: "【" + this.$t("system.machineAddress") + "】"
          }
        ],
        // 账户字典
        zhkeywords: [
          {
            send: "{nickName}",
            look: "【" + this.$t("system.nickName") + "】"
          },
          {
            send: "{userName}",
            look: "【" + this.$t("system.userName") + "】"
          },
          {
            send: "{orderNo}",
            look: "【" + this.$t("system.orderNumber") + "】"
          },
          {
            send: "{orderPrice}",
            look: "【" + this.$t("system.orderPrice") + "】"
          },

          {
            send: "{walletBalance}",
            look: "【" + this.$t("system.walletBalance") + "】"
          }
        ],
        isPayTip: false,
        extensions: this.getExtensions(),
        range: {
          end: 0,
          endText: ""
        }
      };
    },
    computed: {
      hardwareKeywords() {
        const supported = ['{machineName}', '{machineNo}', '{machineAddress}', '{nickName}', '{userName}', '{orderNo}', '{faultType}', '{faultReason}', '{faultDetail}', '{cameraNo}', '{occurredAt}'];
        return this.keywords.filter(item => supported.includes(item.send));
      }
    },
    mounted() {
      this.handlerGetInfo();
    },
    methods: {
      getExtensions() {
        let that = this;
        return [
          new Doc(), // 必须项
          new Text({
            length: 20
          }), // 必须项
          new Paragraph(), // 必须项
          new Heading({ level: 6 }), // 标题
          new Bold({ bubble: true }), // 加粗 bubble: true 在气泡菜单中渲染菜单按钮
          new Underline({ bubble: true, menubar: false }), // 下划线 bubble: true, menubar: false 在气泡菜单而不在菜单栏中渲染菜单按钮
          new Italic({ bubble: true }), // 斜体
          new Strike({ bubble: true }), // 删除线
          new ListItem(), // 使用列表必须项
          new BulletList({ bubble: true }), // 无序列表
          new OrderedList({ bubble: true }), // 有序列表
          new Link(), // 链接
          new Image({
            // 默认会把图片生成 base64 字符串和内容存储在一起，如果需要自定义图片上传
            // 自定义图片上传(默认会把图片生成base64字符串和内容存储到一起)
            // 图片的上传方法，返回一个 Promise<url>
            async uploadRequest(file) {
              // 如果接口要求 Content-Type 是 multipart/form-data，则请求体必须使用 FormData
              const formdata = new FormData();
              //  image是后台接口需要参数名
              formdata.append("file", file);
              //  调用接口进行上传,拿到服务器返回的图片地址
              const res = await that.$api.request(that.$url.common.upload, that.$method.post, formdata);

              if (res.code === 0) {
                return res.data;
              }
              that.$message.warning(res.msg);
              return false;
            }
          }), // 图片
          new CodeBlock({ bubble: true }), // 代码块
          new Blockquote(), // 引用
          new TodoItem(), // 任务列表必须项
          new TodoList(), // 任务列表
          new TextAlign({ bubble: true }), // 文本对齐方式
          new FontSize({ bubble: true }), // 字号
          new FontType({ bubble: true }), // 字体
          new Fullscreen(), // 全屏
          new TextHighlight({ bubble: true }), // 文本高亮
          new TextColor({ bubble: true }), // 文本颜色
          new FormatClear({ bubble: true }), // 清除格式
          new Table({ resizable: true }), // 表格
          new TableHeader(), // 表格必须项
          new TableCell(), // 表格必须项
          new TableRow(), // 表格必须项
          new History(), // 撤销
          new TrailingNode(), // 重做
          new HardBreak(), // 分割线
          new HorizontalRule(), // 行距
          new LineHeight(), // 增加缩进
          new Indent() // 减少缩进
        ];
      },
      // 点击邮件按钮的时候
      emailChangeHandler(value, index, row) {
        if (row.enabled == 1 && value == 1) {
          // 勾选了邮件收费且开关为开
          this.isPayTip = true;
        }
      },
      // 开关更改
      handlerLockChange(value, index, row) {
        let _self = this;
        if (value == 1) {
          this.$confirm(_self.$t("system.payTip"), {
            confirmButtonText: _self.$t("common.definite"),
            cancelButtonText: _self.$t("common.cancel")
          })
            .then(() => {
              if (row.email == 1) {
                _self.isPayTip = true;
              }
            })
            .catch(() => {
              _self.tableData[index].enabled = 0;
            });
        }
      },
      // 获取有无收费项目函数
      async getHasMoney() {
        // 判断是否开启了任何付费项目
        let isOpen = false;
        this.tableData.forEach((item) => {
          if (item.enabled == "1" && (item.phone == "1" || item.email == "1")) {
            isOpen = true;
          }
        });
        // 没收费项
        if (!isOpen) return true;
		// 判断有无零钱
		let localuserid = this.$store.getters.uid;
		let params = {
			uId: localuserid
		};
		const res = await this.$api.request(this.$url.UserFinance.detail, this.$method.get, params);
        if (res.code === 0) {
          if (+res.data.price > 0) {
            return true;
          }
          return false;
        } else {
          this.$message.warning(this.$t("system.cztk"));
          this.loading = false;
        }
      },
      handlerCloseWallet() {
        this.dialogToWallet = false;
        this.loading = false;
      },
      handlerChangeToWallet() {
        clearInterval();
        this.$router.push("/mywallet/topup");
      },
      // 保存--提交
      async handlerSave() {
        let that = this;
        // this.loading = true;
        // let hasMoney = await this.getHasMoney();
        // if (!hasMoney) {
        //   this.dialogToWallet = true;
        //   that.walletTime = 3;
        //   let timer = setInterval(() => {
        //     if (!that.dialogToWallet) {
        //       clearInterval(timer);
        //       return;
        //     }
        //     that.walletTime = that.walletTime - 1;
        //     if (that.walletTime == 0) {
        //       clearInterval(timer);
        //       that.$router.push("/mywallet/topup");
        //     }
        //   }, 1000);
        //   return;
        // }
        // // 循环数组如果没有勾选邮件的 则isPayTip 为false
        // let templock = false;
        // that.tableData.forEach(item => {
        //   if (item.email == 1) {
        //     templock = true;
        //   }
        // });
        // if (!templock) {
        //   //如果没有开的 那就关上
        //   that.isPayTip = false;
        // }
        // if (that.isPayTip) {
        //   // 判断邮件收费
        //   that
        //     .$confirm(that.$t("system.payTip2"), {
        //       confirmButtonText: that.$t("common.definite"),
        //       cancelButtonText: that.$t("common.cancel")
        //     })
        //     .then(_ => {
        //       that.save2();
        //     })
        //     .catch(_ => {
        //       return;
        //     });
        // } else {
        //   that.save2();
        // }
        that.save2();
      },
      isHardwareNotice(row) {
        return ['cameraFault', 'lockFault'].includes(row.wname);
      },
      // 以完整原始配置为基础合并可见行，避免删除隐藏通知和未知字段。
      buildNoticeSettings() {
        const value = JSON.parse(JSON.stringify(this.setting));
        this.tableData.forEach(row => {
          const { wname, type, noticeName, ...fields } = row;
          value[wname] = {
            ...value[wname],
            ...fields,
            emailText: this.filterKey('send', fields.emailText),
            phoneText: this.filterKey('send', fields.phoneText)
          };
        });
        return value;
      },
      async saveNoticeSettings() {
        if (!this.configLoaded || this.loading) return false;
        this.loading = true;
        try {
          const value = this.buildNoticeSettings();
          const savedRows = JSON.parse(JSON.stringify(this.tableData));
          const res = await this.$api.request(this.$url.Promote.save, this.$method.post, {
            type: 'NOTICE', content: JSON.stringify(value)
          });
          if (res.code !== 0) {
            this.$message.warning(res.msg);
            return false;
          }
          this.setting = value;
          this.copyData = savedRows;
          this.isPayTip = false;
          this.$message.success(res.msg);
          return true;
        } catch (err) {
          this.$notify({ title: this.$t('common.tip'), message: err.msg || err.message, type: 'error' });
          return false;
        } finally {
          this.loading = false;
        }
      },
      save2() {
        return this.saveNoticeSettings();
      },
      // 重置
      reset() {
        if (this.loading) return;
        this.tableData = JSON.parse(JSON.stringify(this.copyData));
        this.$message.success(this.$t("system.resetSucess"));
      },
      // 插入
      handlerBlur({ editor }) {
        let wz = window.getSelection().getRangeAt(0);
        // let start = wz.startOffset;
        this.range.end = wz.endOffset;
        this.range.endText = wz.endContainer.nodeValue;
        // 第一步查找endContent的index  然后在index+end处插入文本  若文本endContent为null则为开头
      },
      handlerAddToPoint(word) {
        if (this.range.endText === null) {
          this.nowRow.emailText = word + this.nowRow.emailText;
          return;
        }
        let startIndex = this.nowRow.emailText.indexOf(this.range.endText) + this.range.end; //文本开始索引
        let textarr = this.nowRow.emailText.split("");
        textarr.splice(startIndex, 0, word);
        this.nowRow.emailText = textarr.join("");
      },
      // 添加变量到短信内容
      handlerAddToSmsPoint(word) {
        const textarea = this.$refs.smsForm && this.$refs.smsForm.$el.querySelector('textarea');
        if (textarea) {
          const cursorPos = textarea.selectionStart;
          const textBefore = this.nowRow.phoneText.substring(0, cursorPos);
          const textAfter = this.nowRow.phoneText.substring(cursorPos);
          this.nowRow.phoneText = textBefore + word + textAfter;
          // 设置光标位置到插入文本之后
          this.$nextTick(() => {
            textarea.focus();
            textarea.setSelectionRange(cursorPos + word.length, cursorPos + word.length);
          });
        } else {
          // 如果没有获取到光标位置，就添加到末尾
          this.nowRow.phoneText = this.nowRow.phoneText + word;
        }
      },
      
      // 添加变量到邮件内容
      handlerAddToEmailPoint(word) {
        const textarea = this.$refs.form && this.$refs.form.$el.querySelector('textarea');
        if (textarea) {
          const cursorPos = textarea.selectionStart;
          const textBefore = this.nowRow.emailText.substring(0, cursorPos);
          const textAfter = this.nowRow.emailText.substring(cursorPos);
          this.nowRow.emailText = textBefore + word + textAfter;
          // 设置光标位置到插入文本之后
          this.$nextTick(() => {
            textarea.focus();
            textarea.setSelectionRange(cursorPos + word.length, cursorPos + word.length);
          });
        } else {
          // 如果没有获取到光标位置，就添加到末尾
          this.nowRow.emailText = this.nowRow.emailText + word;
        }
      },
      // launch
      handlerGetInfo() {
        let _self = this;
        _self.loading = true;
        let url = _self.$url.Promote.get;
        let method = _self.$method.get;
        _self.configLoaded = false;
        Promise.all([
          _self.$api.request(url, method, { type: 'NOTICE' }),
          _self.$api.request(_self.$url.Promote.hardwareOptions, method)
        ]).then(([res, options]) => {
          if (res.code !== 0 || options.code !== 0) {
            throw new Error(res.code !== 0 ? res.msg : options.msg);
          }
          _self.setting = JSON.parse(JSON.stringify(res.data));
          const keepKeys = ['online30', 'onlineDay', 'stock', 'cameraFault', 'lockFault'];
          _self.tableData = keepKeys.filter(key => res.data[key] || ['cameraFault', 'lockFault'].includes(key)).map(key => {
            const hardware = ['cameraFault', 'lockFault'].includes(key);
            const option = options.data.find(item => item.settingKey === key);
            const defaults = hardware ? {
              enabled: '0', self: '1', repair: '1', email: '1', phone: '0'
            } : {};
            const row = { ...defaults, ...res.data[key], wname: key, type: hardware ? 4 : 2 };
            if (hardware) {
              row.lang = 'en_US';
            }
            row.noticeName = option ? option.name : '';
            row.emailText = _self.filterKey('look', row.emailText);
            row.phoneText = _self.filterKey('look', row.phoneText);
            row.emailTitle = row.emailTitle || '';
            row.phoneTitle = row.phoneTitle || '';
            return row;
          });
          _self.copyData = JSON.parse(JSON.stringify(_self.tableData));
          _self.configLoaded = true;
        }).catch(err => {
          _self.$notify({ title: _self.$t('common.tip'), message: err.msg || err.message, type: 'error' });
        }).finally(() => {
          _self.loading = false;
        });
        // 获取短信费用
        let urls = _self.$url.Promote.getDictValue;
        let methods = _self.$method.get;
        _self.$api
          .request(urls, methods, {
            type: "service_type_amount",
            label: "WALLET_SMS"
          })
          .then(res => {
            if (res.code === 0) {
              try {
                this.smsprice = parseFloat(res.data[0].value);
              } catch (error) {
              }
            }
          })
          .catch(err => {
            _self.$notify({
              title: _self.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      // 编辑短信
      handlerExitOne(row) {
        this.nowRow = { ...row };
        this.exitDialogVisible = true;
      },
      // 编辑短信内容
      handlerEditSms(row) {
        // 创建一个副本，将显示格式转换为编辑格式
        this.nowRow = { 
          ...row,
          // 保持显示格式用于编辑
          phoneText: row.phoneText,
          phoneTitle: row.phoneTitle || ''
        };
        this.smsDialogVisible = true;
      },
      // 模板确认后才合并到表格；失败保留弹窗内容以便重试。
      async saveEmailContent() {
        if (this.loading) return;
        if (await this.saveSingleEmailToBackend(this.nowRow.wname, this.nowRow.emailTitle, this.nowRow.emailText)) {
          this.exitDialogVisible = false;
        }
      },
      async saveSmsContent() {
        if (this.loading) return;
        if (await this.saveSingleSmsToBackend(this.nowRow.wname, this.nowRow.phoneTitle, this.nowRow.phoneText)) {
          this.smsDialogVisible = false;
        }
      },
      saveSingleEmailToBackend(wname, emailTitle, emailText) {
        if (this.loading) return false;
        const row = this.tableData.find(item => item.wname === wname);
        Object.assign(row, { emailTitle, emailText });
        return this.saveNoticeSettings();
      },
      saveSingleSmsToBackend(wname, phoneTitle, phoneText) {
        if (this.loading) return false;
        const row = this.tableData.find(item => item.wname === wname);
        Object.assign(row, { phoneTitle, phoneText });
        return this.saveNoticeSettings();
      },
      saveSmsToBackend() {
        return this.saveNoticeSettings();
      },
      // 查看tips
      handlerLookTips(n, content) {
        n == 1 ? (this.lookTips.title = "SMS") : (this.lookTips.title = "MAIL");
        content = this.filterKey("look", content);
        this.lookTips.content = this.stripHtml(content);
        this.lookTips.dialogVisible = true;
      },
      filterKey(methods, str) {
        str = str || "";
        let unMethods = "";
        if (methods == "look") {
          unMethods = "send";
        } else {
          unMethods = "look";
        }
        
        this.keywords.forEach(item => {
          str = str.replace(new RegExp(this.escapeRegExp(item[unMethods]), 'g'), item[methods]);
        });
        return str;
      },
      
      // Helper function to escape special regex characters
      escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      },
      stripHtml(string) {
        if (!string) {
          return "";
        }
        return String(string)
          .replace(/<br\s*\/?>/gi, "\n")
          .replace(/<[^>]*>/g, "")
          .trim();
      }
    }
  };
</script>

<style lang="scss" scoped>
  .add-product {
    ::v-deep .el-dialog__body {
      height: auto;
      padding: 10px 30px;
    }
    ::v-deep .el-form-item__content {
      line-height: 40px;
    }
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .ca {
    color: #aaa;
    ::v-deep .el-form-item__label {
      color: #aaa;
    }
  }
</style>
